import { endPoint } from "./base.config";

export const companyPaymentPackages = {
  add: `${endPoint}company-payment-packages`,
  update: `${endPoint}company-payment-packages/:id`,
  getByCompanyId: `${endPoint}company-payment-packages`,
}